import React from 'react';
import useLegalPage from '../../hooks/useLegalPage';
import LegalPageLayout from '../../components/legal/LegalPageLayout';

const PrivacyPolicyPage = () => {
  const { page, loading, error, refetch } = useLegalPage('privacy-policy');

  return (
    <LegalPageLayout
      page={page}
      loading={loading}
      error={error}
      onRetry={refetch}
    />
  );
};

export default PrivacyPolicyPage;
